module.exports = __webpack_public_path__ + "images/dec36425c5a5e9d4c7653717692bbf56.jpg";